import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lf-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
    ],
})
export class ToggleSwitchComponent
{
    @Input() public checked: boolean = false;
    @Input() public readonly: boolean = false;
    @Input() public disabled: boolean = false;
    @Input() public color: string = 'blue';

    @Output() public changed: EventEmitter<boolean> = new EventEmitter<boolean>();

    public toggleState() {
        this.checked = !this.checked;
        this.changed.emit(this.checked);
    }
}
